import * as React from 'react'

const CloseLeft = () => {
  return (
    <svg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.95811 9.8751L0.157678 5.37885C-0.0525594 5.17902 -0.0525594 4.84596 0.157678 4.64613L4.95811 0.149875C5.16835 -0.0499592 5.51874 -0.0499592 5.72898 0.149875L6.49985 0.882598C6.71009 1.08243 6.71009 1.41549 6.49985 1.61532L3.20613 4.64613C2.99589 4.84596 2.99589 5.17902 3.20613 5.37885L6.46481 8.40966C6.67505 8.60949 6.67505 8.94255 6.46481 9.14238L5.69394 9.8751C5.4837 10.0416 5.16835 10.0416 4.95811 9.8751ZM12.3009 9.8751L7.50045 5.37885C7.29021 5.17902 7.29021 4.84596 7.50045 4.64613L12.3009 0.149875C12.5111 -0.0499592 12.8615 -0.0499592 13.0718 0.149875L13.8426 0.882598C14.0529 1.08243 14.0529 1.41549 13.8426 1.61532L10.5489 4.64613C10.3387 4.84596 10.3387 5.17902 10.5489 5.37885L13.8076 8.40966C14.0178 8.60949 14.0178 8.94255 13.8076 9.14238L13.0367 9.8751C12.8265 10.0416 12.4761 10.0416 12.3009 9.8751Z'
        fill='white'
        fill-opacity='0.5'
      />
    </svg>
  )
}
export default CloseLeft



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/CloseLeft.tsx